<template>
  <div ref="wrapper" class="list-wrapper">
    <div class="scroll-content">
      <div class="scroll-item" ref="listWrapper">
        <slot></slot>
      </div>
      <slot name="pullup" :pullUpLoad="pullUpLoad" :isPullUpLoad="isPullUpLoad">
        <div class="pullup-wrapper" v-if="pullUpLoad">
          <div class="before-trigger" v-if="!isPullUpLoad">
            <span>{{$t(pullUpTxt)}}</span>
          </div>
          <div class="after-trigger" v-else>
            <loading></loading>
          </div>
        </div>
      </slot>
    </div>
    <slot name="pulldown" :pullDownRefresh="pullDownRefresh" :pullDownStyle="pullDownStyle" :beforePullDown="beforePullDown"
      :isPullingDown="isPullingDown" :bubbleY="bubbleY">
      <div ref="pulldown" class="pulldown-wrapper" :style="pullDownStyle" v-if="pullDownRefresh">
        <div class="before-trigger" v-if="beforePullDown">
          <bubble :y="bubbleY"></bubble>
        </div>
        <div class="after-trigger" v-else>
          <div v-if="isPullingDown" class="loading">
            <loading></loading>
          </div>
          <div v-else>
            <span>{{$t(refreshTxt)}}</span>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
  import BScroll from 'better-scroll'
  import Loading from './loading.vue'
  import Bubble from './bubble.vue'
  import {
    getRect
  } from './dom.js'
  const COMPONENT_NAME = 'scroll'
  const DIRECTION_H = 'horizontal'
  const DIRECTION_V = 'vertical'
  export default {
    name: COMPONENT_NAME,
    props: {
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      ScrollIndex: {
        default: 0
      },
      probeType: {
        type: Number,
        default: 1
      },
      click: {
        type: Boolean,
        default: true
      },
      listenScroll: {
        type: Boolean,
        default: false
      },
      listenBeforeScroll: {
        type: Boolean,
        default: false
      },
      listenScrollEnd: {
        type: Boolean,
        default: false
      },
      direction: {
        type: String,
        default: DIRECTION_V
      },
      scrollbar: {
        type: null,
        default: false
      },
      pullDownRefresh: {
        type: null,
        default: false
      },
      pullUpLoad: {
        type: null,
        default: false
      },
      startY: {
        type: Number,
        default: 0
      },
      refreshDelay: {
        type: Number,
        default: 20
      },
      freeScroll: {
        type: Boolean,
        default: false
      },
      mouseWheel: {
        type: Boolean,
        default: false
      },
      bounce: {
        default: true
      },
      zoom: {
        default: false
      }
    },
    data() {
      return {
        beforePullDown: true,
        isRebounding: false,
        isPullingDown: false,
        isPullUpLoad: false,
        pullUpDirty: true,
        pullDownStyle: '',
        bubbleY: 0
      }
    },
    computed: {
      pullUpTxt() {
        if (this.data.length <= 0) {
          return
        }
        const moreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.more) ||
          'share.pullUpLoadMoreTxt';
        const noMoreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.noMore) ||
          'share.pullUpLoadNoMoreTxt';
        return this.pullUpDirty ? moreTxt : noMoreTxt;
      },
      refreshTxt() {
        return (this.pullDownRefresh && this.pullDownRefresh.txt) || 'share.RefreshTheSuccess';
      }
    },
    created() {
      this.pullDownInitTop = -50;
    },
    mounted() {
      let __self = this;
      __self.$nextTick(function () {
        __self.initScroll();
      })
    },
    destroyed() {
      this.$refs.scroll && this.$refs.scroll.destroy();
    },
    methods: {
      initScroll() {
        if (!this.$refs.wrapper) {
          return
        }
        if (this.$refs.listWrapper && (this.pullDownRefresh || this.pullUpLoad)) {
          this.$refs.listWrapper.style.minHeight = `${getRect(this.$refs.wrapper).height + 1}px`;
        }
        let options = {
          probeType: this.probeType,
          click: this.click,
          scrollY: this.freeScroll || this.direction === DIRECTION_V,
          scrollX: this.freeScroll || this.direction === DIRECTION_H,
          scrollbar: this.scrollbar,
          pullDownRefresh: this.pullDownRefresh,
          pullUpLoad: this.pullUpLoad,
          startY: this.startY,
          freeScroll: this.freeScroll,
          mouseWheel: this.mouseWheel,
          bounce: this.bounce,
          zoom: this.zoom
        }
        this.scroll = new BScroll(this.$refs.wrapper, options);
        if (document.querySelector('.calendar')) {
          let calendar = document.querySelector('.calendar');
          let listWrapper = calendar.querySelector('.list-wrapper');
          if (listWrapper != null) {
            let li = listWrapper.getElementsByTagName('li')
            this.scroll.scrollToElement(li[this.ScrollIndex], 0)
          }
        }
        // if (document.querySelector('.selectDate')) {
        //   let calendar = document.querySelector('.calendar')
        //   let ScrollItem = calendar.querySelector('.scroll-item')
        //   let ul=ScrollItem.getElementsByTagName('ul')[0]
        //   let li=ul.getElementsByTagName('li')
        //   let index = document.querySelector('.selectDate').offsetTop - 610;
        //   this.scroll.scrollTo(0, -index, 0)
        // }
        if (this.listenScroll) {
          this.scroll.on('scroll', (pos) => {
            this.$emit('scroll', pos);
          })
        }
        if (this.listenScrollEnd) {
          this.scroll.on('scrollEnd', (pos) => {
            this.$emit('scroll-end', pos);
          })
        }
        if (this.listenBeforeScroll) {
          this.scroll.on('beforeScrollStart', () => {
            this.$emit('beforeScrollStart');
          })
          this.scroll.on('scrollStart', () => {
            this.$emit('scroll-start');
          })
        }
        if (this.pullDownRefresh) {
          this._initPullDownRefresh();
        }
        if (this.pullUpLoad) {
          this._initPullUpLoad();
        }
      },
      disable() {
        this.scroll && this.scroll.disable();
      },
      enable() {
        this.scroll && this.scroll.enable();
      },
      refresh() {
        this.scroll && this.scroll.refresh();
      },
      scrollTo() {
        this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
      },
      scrollToElement() {
        this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
      },
      clickItem(e, item) {
        this.$emit('click', item);
      },
      destroy() {
        this.scroll.destroy();
      },
      forceUpdate(dirty) {
        if (this.pullDownRefresh && this.isPullingDown) {
          this.isPullingDown = false;
          this._reboundPullDown().then(() => {
            this._afterPullDown();
          })
        } else if (this.pullUpLoad && this.isPullUpLoad) {
          this.pullUpDirty = dirty;
          this.isPullUpLoad = false;
          this.scroll.finishPullUp();
          this.refresh();
        } else {
          this.refresh();
        }
      },
      _initPullDownRefresh() {
        this.scroll.on('pullingDown', () => {
          if (this.data.length <= 0) {
            return
          }
          this.beforePullDown = false;
          this.isPullingDown = true;
          this.$emit('pullingDown');
        })
        this.scroll.on('scroll', (pos) => {
          if (this.data.length <= 0) {
            return
          }
          if (!this.pullDownRefresh) {
            return
          }
          if (this.beforePullDown) {
            this.bubbleY = Math.max(0, pos.y + this.pullDownInitTop);
            this.pullDownStyle = `top:${Math.min(pos.y + this.pullDownInitTop, 10)}px`;
          } else {
            this.bubbleY = 0;
          }
          if (this.isRebounding) {
            this.pullDownStyle = `top:${10 - (this.pullDownRefresh.stop - pos.y)}px`;
          }
        })
      },
      _initPullUpLoad() {
        this.scroll.on('pullingUp', () => {
          if (this.data.length <= 0) {
            return
          }
          this.isPullUpLoad = true;
          this.$emit('pullingUp');
        })
      },
      _reboundPullDown() {
        const {
          stopTime = 600
        } = this.pullDownRefresh
        return new Promise((resolve) => {
          setTimeout(() => {
            this.isRebounding = true;
            this.scroll.finishPullDown();
            resolve()
          }, stopTime)
        })
      },
      _afterPullDown() {
        setTimeout(() => {
          this.pullDownStyle = `top:${this.pullDownInitTop}px`;
          this.beforePullDown = true;
          this.isRebounding = false;
          this.refresh();
        }, this.scroll.options.bounceTime);
      }
    },
    watch: {
      data(newVal) {
        setTimeout(() => {
          this.forceUpdate(true);
        }, this.refreshDelay)
      },
    },
    components: {
      Loading,
      Bubble
    }
  }

</script>

<style>
  .list-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
  }

  .scroll-content {
    position: relative;
    z-index: 1;
  }

  .list-content {
    position: relative;
    z-index: 10;
    background: #fff;
  }

  .list-item {
    height: 0.6rem;
    line-height: 0.6rem;
    font-size: 0.18rem;
    padding-left: 0.2rem;
    border-bottom: 0.01rem solid #e5e5e5;
  }

  .pulldown-wrapper {
    position: absolute;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all;
  }

  .pulldown-wrapper .after-trigger {
    /* margin-top: 0.1rem; */
  }

  .pullup-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.16rem 0;
  }

</style>



// WEBPACK FOOTER //
// Scroll.vue?50d94e0d